import { Design } from '@/types';

export const isFreeDesign = (design: Design) => design?.free;
